import { createApp } from 'vue'

import Cookies from 'js-cookie'

import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import locale from 'element-plus/es/locale/lang/zh-cn'
import print from 'vue3-print-nb'
import '@/modules/huyu-framework/backend/assets/styles/index.scss' // global css

// jessibuca-pro 内部会调用 PressureObserver.observe()，销毁过程中可能会因
// disconnect + observe 竞争导致未处理的 Promise 被 reject（AbortError）。
// 这里做一个轻量级兜底，避免浏览器控制台报错以及开发环境弹出错误蒙层。
if (typeof window !== 'undefined' && typeof window.addEventListener === 'function') {
  window.addEventListener('unhandledrejection', (event) => {
    try {
      const reason = event && event.reason;
      if (!reason) return;
      const msg = (typeof reason === 'string' ? reason : (reason.message || reason.name || '')) + '';
      // 过滤 jessibuca / PressureObserver / AbortError / observe / disconnect 这类错误
      if (
        msg.indexOf('AbortError') !== -1 ||
        msg.indexOf('PressureObserver') !== -1 ||
        msg.indexOf('observe') !== -1
      ) {
        // eslint-disable-next-line no-console
        console.warn('[jessibuca] suppress unhandled promise rejection:', reason);
        event.preventDefault && event.preventDefault();
        event.stopPropagation && event.stopPropagation();
        return;
      }
      // 过滤 jessibuca 内部销毁/切换期间的其他非关键 reject
      if (typeof reason === 'object' && reason !== null) {
        const s = JSON.stringify(reason);
        if (s && (s.indexOf('jessibuca') !== -1 || s.indexOf('Jessibuca') !== -1)) {
          // eslint-disable-next-line no-console
          console.warn('[jessibuca] suppress unhandled promise rejection:', reason);
          event.preventDefault && event.preventDefault();
          event.stopPropagation && event.stopPropagation();
        }
      }
    } catch (e) {}
  });
}

import App from './App'
import store from './store'
import router from './router'
import directive from '@/modules/huyu-framework/backend/directive' // directive





import VxeUIAll from 'vxe-pc-ui'
import 'vxe-pc-ui/lib/style.css'
import VxeUITable from 'vxe-table'
import 'vxe-table/lib/style.css'
// 注册指令
import plugins from '@/modules/huyu-framework/backend/plugins' // plugins
import { download } from '@/modules/huyu-framework/backend/utils/request'

// svg图标
import 'virtual:svg-icons-register'
import SvgIcon from '@/modules/huyu-framework/backend/components/SvgIcon'
import elementIcons from '@/modules/huyu-framework/backend/components/SvgIcon/svgicon'

import './permission' // permission control

import { useDict } from '@/modules/huyu-framework/backend/utils/dict'
import { parseTime, resetForm, addDateRange, handleTree, selectDictLabel, selectDictLabels } from '@/modules/huyu-framework/backend/utils/ruoyi'

// 分页组件
import Pagination from '@/modules/huyu-framework/backend/components/Pagination'
// 自定义表格工具组件
import RightToolbar from '@/modules/huyu-framework/backend/components/RightToolbar'
// 富文本组件
import Editor from "@/modules/huyu-framework/backend/components/Editor"
// 文件上传组件
import FileUpload from "@/modules/huyu-framework/backend/components/FileUpload"
// 图片上传组件
import ImageUpload from "@/modules/huyu-framework/backend/components/ImageUpload"

// 视频上传组件
import VideoUpload from "@/modules/huyu-framework/backend/components/VideoUpload"
// 图片预览组件
import ImagePreview from "@/modules/huyu-framework/backend/components/ImagePreview"
// 自定义树选择组件
import TreeSelect from '@/modules/huyu-framework/backend/components/TreeSelect'
// 字典标签组件
import DictTag from '@/modules/huyu-framework/backend/components/DictTag'

const app = createApp(App)

// 全局方法挂载
app.config.globalProperties.useDict = useDict
app.config.globalProperties.download = download
app.config.globalProperties.parseTime = parseTime
app.config.globalProperties.resetForm = resetForm
app.config.globalProperties.handleTree = handleTree
app.config.globalProperties.addDateRange = addDateRange
app.config.globalProperties.selectDictLabel = selectDictLabel
app.config.globalProperties.selectDictLabels = selectDictLabels

// 全局组件挂载
app.component('DictTag', DictTag)
app.component('Pagination', Pagination)
app.component('TreeSelect', TreeSelect)
app.component('FileUpload', FileUpload)
app.component('ImageUpload', ImageUpload)
app.component('VideoUpload', VideoUpload)

app.component('ImagePreview', ImagePreview)
app.component('RightToolbar', RightToolbar)
app.component('Editor', Editor)


app.use(print)
app.use(router)
app.use(store)
app.use(plugins)
app.use(elementIcons)

app.use(VxeUIAll)
app.use(VxeUITable)

app.component('svg-icon', SvgIcon)

directive(app)

// 使用element-plus 并且设置全局的大小
app.use(ElementPlus, {
  locale: locale,
  // 支持 large、default、small
  size: Cookies.get('size') || 'default'
})

app.mount('#app')
